// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"7bcfe8c0","359":"84f338b3","422":"a03b112f","838":"9e6c4f4f","987":"8bff9ef7"}[chunkId] + ".chunk.js";
};